import { all } from 'redux-saga/effects'

import templateSagas from './Template'
import scriptSagas from './Script'

export default function* rootSaga (getState) {
  yield all([templateSagas(), scriptSagas()])
}



// WEBPACK FOOTER //
// ./sagas/index.js